<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="产品名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="产品名称搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="所属客户" prop="client_id">
                <el-select
                    v-model="form.client_id"
                    placeholder="选择客户"
                    class="client_idc"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="client in AllClient"
                        :key="client.name"
                        :label="client.name"
                        :value="client.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属仓库" prop="storeroom_id">
                <el-cascader
                    v-model="form.storeroom_id"
                    :options="storeroom_in_enterprise"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    @change="(storeroom_id) => get_location(storeroom_id)"
                    class="storeroomc"
                >
                </el-cascader>
            </el-form-item>
            <el-form-item label="所在库位" prop="localtion_id">
                <el-select
                    v-model="form.localtion_id"
                    filterable
                    placeholder="选择库位"
                    class="localtionc"
                    clearable
                >
                    <el-option
                        v-for="localtion in location_in_storeroom"
                        :key="localtion.id"
                        :label="localtion.name"
                        :value="localtion.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import { enterprise_storeroom_request } from '@/network/enterprise.js'
import { location_list_request} from '@/network/list.js'

export default {
    name: 'StockCountSearchBarComponent',
    data() {
        return {
            form: {
                name: '',
                client_id: '',
                storeroom_id: '',
                localtion_id: '',
                page: 1,
            },
            storeroom_in_enterprise: [],
            location_in_storeroom: []
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        get_enterprise_storeroom() {
            enterprise_storeroom_request()
                .then((s) => {
                    if (s.status === 0) {
                        this.storeroom_in_enterprise = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_location(storeroom_id) {
            this.location_in_storeroom = []
            this.form.localtion_id = ''
            const storeroom = storeroom_id[storeroom_id.length -1]
            if (storeroom) {
                location_list_request({storeroom_id:storeroom})
                    .then((s) => {
                        if (s.status === 0) {
                            this.location_in_storeroom = s.result
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err)
                    })
            }
        },
    },
    filters: {},
    props: {
        AllClient: {
            type: Array,
            default() {
                return []
            },
        },
    },
    created() {
        this.get_enterprise_storeroom()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style></style>